/* eslint-disable no-console */
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

export const sendGAEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, {
      send_to: process.env.gtagId,
      ...parameters,
    });
    console.info(`GA Event sent: ${eventName}`, parameters);
  } else {
    console.info('Google Analytics (gtag) is not available');
  }
};
